import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/app/UI";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { HrDashboard } from "@/components/leave/HrDashboard";
import { HrApplications } from "@/components/leave/HrApplications";
import { HrBalances } from "@/components/leave/HrBalances";
import { HrEmployees } from "@/components/leave/HrEmployees";
import { HrPolicy } from "@/components/leave/HrPolicy";

const TABS = [
  ["dashboard", "Dashboard", HrDashboard],
  ["applications", "Leave Applications", HrApplications],
  ["balances", "Leave Balances", HrBalances],
  ["employees", "Employees", HrEmployees],
  ["policy", "Policy & Holidays", HrPolicy],
];

export default function LeaveManagement() {
  const [tab, setTab] = useState("dashboard");
  const [allowed, setAllowed] = useState(null);
  useEffect(() => { api.get("/leave/policy/access").then((r) => setAllowed(!!r.data.is_hr)).catch(() => setAllowed(false)); }, []);
  if (allowed === null) return <div className="p-8 text-sm text-[#9CA3AF]">Loading…</div>;
  if (!allowed) return (
    <div className="px-4 sm:px-8 py-6 space-y-6">
      <PageHeader eyebrow="HR & Payroll" title="Leave Management" />
      <div className="flat-card p-8 text-sm" data-testid="hr-leave-no-access">You don't have HR leave permission. Ask an admin to enable "Leave Management (HR)" for your role.</div>
    </div>
  );
  return (
    <div className="px-4 sm:px-8 py-6 space-y-6" data-testid="leave-management-page">
      <PageHeader eyebrow="HR & Payroll" title="Leave Management" subtitle="Applications, balances, employees and leave policy" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="rounded-none mb-4 flex-wrap h-auto">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} className="rounded-none" data-testid={`hr-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k}>{tab === k && <C goTo={setTab} />}</TabsContent>)}
      </Tabs>
    </div>
  );
}
